'use client'

import React from 'react'

import { useFilter } from '@rewardops/ui'

import { SEARCH_QUERY_MIN_LENGTH } from '~/utils/sort-utils'
import { useParametersFilter } from '~/components/hooks/filters/use-parameters-filter'
import { useRootCategoriesFilter } from '~/components/hooks/filters/use-root-categories-filter'
import ResponsiveComponent from '~/components/responsive-component'
import DesktopProductsSearch from './desktop-products-search'
import MobileProductsSearch from './mobile-products-search'

export type ProductsSearchProps = {
  isFiltersLoading: boolean
  brandsFilterOptions: any[] | undefined
  categoriesFilterOptions: any[] | undefined
  itemSearchState?: { totalItems: number | undefined; loading: boolean }
  setItemSearchState: React.Dispatch<
    React.SetStateAction<{ totalItems: number | undefined; loading: boolean }>
  >
}

const ProductsSearch = () => {
  const { searchQuery } = useFilter()

  const [itemSearchState, setItemSearchState] = React.useState<{
    totalItems: number | undefined
    loading: boolean
  }>({
    totalItems: 0,
    loading: false,
  })

  const enableFilters =
    !!itemSearchState?.totalItems &&
    searchQuery?.length >= SEARCH_QUERY_MIN_LENGTH

  const {
    brands: brandsFilterOptions,
    subCategoriesCodes,
    loading: isParametersLoading,
  } = useParametersFilter({
    searchQuery: searchQuery,
    enabled: enableFilters,
  })

  const { categories: categoriesFilterOptions, loading: isCategoriesLoading } =
    useRootCategoriesFilter({
      filter: {
        subCategories: subCategoriesCodes,
      },
      enabled: enableFilters,
    })

  const desktopComponent = (
    <DesktopProductsSearch
      isFiltersLoading={!!isCategoriesLoading || !!isParametersLoading}
      brandsFilterOptions={brandsFilterOptions}
      categoriesFilterOptions={categoriesFilterOptions}
      setItemSearchState={setItemSearchState}
    />
  )

  const mobileComponent = (
    <MobileProductsSearch
      isFiltersLoading={!!isCategoriesLoading || !!isParametersLoading}
      brandsFilterOptions={brandsFilterOptions}
      categoriesFilterOptions={categoriesFilterOptions}
      setItemSearchState={setItemSearchState}
    />
  )

  return (
    <ResponsiveComponent
      desktopComponent={desktopComponent}
      mobileComponent={mobileComponent}
    />
  )
}

export default ProductsSearch
